import { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { createPortal } from 'react-dom';

type Props = {
  title: string;
  message?: string | JSX.Element;
  confirmButton?: string;
  confirmClassName?: string;
  cancelButton?: string;
  cancelClassName?: string;
  size?: 'sm' | 'lg' | 'xl' | undefined;
  onProceed?: (proceed: boolean) => void;
  noCancelButton?: boolean;
  modalClassName?: string;
  overlay?: boolean;
  overlayOpacity?: number;
  overlayZIndex?: number;
};

export function ConfirmDialog(props: Props) {
  let pressed = false;
  return confirmAlert({
    customUI: ({ onClose }) => {
      const overlayZIndex = props.overlayZIndex ?? 2000;
      return (
        <div className="static-modal">
          {props.overlay &&
            createPortal(
              <div
                style={{
                  position: 'fixed',
                  inset: 0,
                  background: `rgba(0, 0, 0, ${props.overlayOpacity ?? 0.35})`,
                  zIndex: overlayZIndex,
                }}
                onClick={() => {
                  if (pressed) return;
                  pressed = true;
                  props.onProceed && props.onProceed(false);
                  onClose();
                }}
              />,
              document.body
            )}
          <Modal
            animation={false}
            show={true}
            onHide={() => {
              props.onProceed && props.onProceed(false);
              onClose();
            }}
            backdrop={!props.overlay}
            centered
            size={props.size}
            contentClassName={props.modalClassName}
            style={props.overlay ? { zIndex: overlayZIndex + 1 } : undefined}
          >
            <Modal.Header>
              <Modal.Title>{props.title || 'Are you sure?'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{props.message}</Modal.Body>
            <Modal.Footer>
              {!props.noCancelButton && (
                <div
                  className={
                    (props.cancelClassName || 'btn btn-outline btn-outline-primary btn-sm me-5') +
                    (pressed ? ' disabled' : '')
                  }
                  onClick={() => {
                    if (pressed) return;
                    pressed = true;
                    props.onProceed && props.onProceed(false);
                    onClose();
                  }}
                >
                  {props.cancelButton || 'Cancel'}
                </div>
              )}
              <div
                className={(props.confirmClassName || 'btn btn-primary btn-sm') + (pressed ? ' disabled' : '')}
                onClick={() => {
                  if (pressed) return;
                  pressed = true;
                  props.onProceed && props.onProceed(true);
                  onClose();
                }}
              >
                {props.confirmButton || 'Yes'}
              </div>
            </Modal.Footer>
          </Modal>
        </div>
      );
    },
    // title: 'Remove Attachment?',
    // message: `Are you sure you'd like to remove ${doc.filename}?`,
    // buttons: [
    //   {
    //     label: 'Yes',
    //     onClick: () => {
    //       deattachFile(doc);
    //     },
    //   },
    //   {
    //     label: 'No',
    //     onClick: () => {},
    //   },
    // ],
  });
}
